import Screenshot from '../views/screenshot.vue';
import screenshotPanel from '../components/rightPanel/screenshotPanel.vue';
export default {
  path: '/screenshot',
  components: {
    default: Screenshot,
    panel: screenshotPanel
  }
};

// component: () => import(/* webpackChunkName: "about" */ '@/views/home.vue')
